module.exports = __webpack_public_path__ + "media/images/gifts/care/sug_cuidar_5-e21b1a393fa19d63d0d89095f69ea801.jpg";